import viewActions from '../constants/ViewActions';

import { notifyCriticalRenderPath } from './Application';

/**
 * Action creator triggered by any interactions on the Now Playing component
 *
 */

export function toggleTprText(isFaded) {
  return {
    type: viewActions.TOGGLE_TPR_TEXT,
    data: { isFaded },
  };
}

export function openNowPlaying() {
  return {
    type: viewActions.OPEN_NOW_PLAYING,
  };
}

export function closeNowPlaying() {
  return {
    type: viewActions.CLOSE_NOW_PLAYING,
  };
}

export function openSessionHistory(historySize) {
  return {
    type: viewActions.OPEN_SESSION_HISTORY,
    historySize,
  };
}

export function closeSessionHistory({ isLeavingNowPlaying = false }) {
  return {
    type: viewActions.CLOSE_SESSION_HISTORY,
    data: { isLeavingNowPlaying },
  };
}

export function hoveredOverStationList() {
  return {
    type: viewActions.HOVERED_OVER_STATION_LIST,
  };
}

export function hoveredOutStationList() {
  return {
    type: viewActions.HOVERED_OUT_STATION_LIST,
  };
}

export function clickedSearchBoxComponent() {
  return {
    type: viewActions.CLICKED_SEARCH_BOX_COMPONENT,
  };
}

export function setSessionHistoryIndex(sessionHistoryIndex) {
  return dispatch => {
    dispatch(notifyCriticalRenderPath());
    return dispatch({
      type: viewActions.SET_SESSION_HISTORY_INDEX,
      sessionHistoryIndex,
    });
  };
}
